
import {Component, Vue} from "vue-property-decorator";
import ContentPageLayout from "@/components/UI/renewal/ContentPageLayout.vue";
import SecurityPolicyContent from "@/components/security-policy/SecurityPolicyContent.vue";

@Component({
  components: {
    ContentPageLayout,
    SecurityPolicyContent,
  },
})
export default class SecurityPolicy extends Vue {
}
